import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const height: AnswerPathTreeNode = { path: 'height', nodeId: NodeIds.insuredHeight };
